import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookieServiceWrapper  {
private cookieService=inject(CookieService)
  getConsentCookie(): boolean {
    const consentCookie = this.cookieService.get('cookieConsent');
    return consentCookie === 'true';
  }
  setConsentCookie(consent: boolean): void {
    this.cookieService.set('cookieConsent', consent ? 'true' : 'false', 365);
  }
}
